module.exports = __webpack_public_path__ + "static/media/sanitaer.6eacb63e.jpg";